import gql from 'graphql-tag'
import client from '../../stores/apollo'
import api from '@api'
import { NeighborhoodFragment } from '@api/fragments'
import { INeighborhood } from '@api/types'
import { ApolloError } from 'apollo-boost'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  addSpacesToNeighborhood: {
    neighborhood: INeighborhood
  }
}

const mutation = gql`
  mutation UpdateSpaceNeighborhoods($input: AddSpacesToNeighborhoodInput!) {
    addSpacesToNeighborhood(input: $input) {
      neighborhood {
        ...NeighborhoodFragment
      }
    }
  }
  ${NeighborhoodFragment}
`

const mutateHandler = handleFetchResult<IPayload, INeighborhood>({
  handler: (data) => data.addSpacesToNeighborhood.neighborhood,
  name: 'Neighborhood Spaces',
})

export default async function addSpacesToNeighborhood(
  neighborhoodId: string,
  spaceIds: string[]
): Promise<INeighborhood> {
  const input = { neighborhoodId, spaceIds }

  try {
    await api.space.batchUpdateUsageTypes(spaceIds, 'neighborhood').catch((e: ApolloError) => e)
    return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
  } catch (e: any) {
    return e
  }
}
